import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "react-oidc-context";
import { makeStyles } from "@material-ui/core/styles";
//import { useNavigate } from "react-router-dom";
import {
    Container,
    Box,
    Grid,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    AppBar,
    Tabs,
    Tab,
    Typography,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
//import "./Login.scss";
import SiemensLogo from "../../assets/images/LogoInnomotics.jpg";
import {
    validateTheUserBasedOnApi,
    authenticateExternalUser,
    AuthenticateSpecialUser1,
    generateTokenOnly,
    authenticateCustomer,
    AuthenticateCustomerEmail
} from "../../APIs/api_Login";
import {
    storeUserDetailsAction,
    isVerifiedOTPAction,
    isForgotPasswordAction,
    custHeaderAction,
    isExternalOTPVerified,
    saveBearerTokenAction,
    saveUserIdAction
} from "../../Redux/Actions/actions";
//import Timer from "../../Components/CountdownTimer/Timer";
import Timer from "../../Components/CountdownTimer/Timer";
//import Loader from "../Components/Loader/Loader";
import Loader from "../../Components/Loader/Loader";
import { forgotUserPassword } from "../../APIs/api_UserManagement";
//import { generateTokenOnly } from "../../Redux/API/api_Login";
//import { gridColumnsTotalWidthSelector } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { spocEmail } from "../../Utilities/Utility";
//import { useAuth0 } from "@auth0/auth0-react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
//import ChangePassword from "../ChangePassword/ChangePassword";
import { useHistory } from "react-router-dom";


import { ResetUserPassword, verifyOTP, verifyOTPForCustomer } from "../../APIs/api_UserManagement";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { InputAdornment } from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: "rgba(0, 204, 204, .05)",
        // backdropFilter: "blur(3px)",
        minHeight: "100vh",
        overflow: "auto",
    },
    paper: {
        padding: theme.spacing(2),
    },
    errorMessage: {
        color: "var(--red)",
        fontSize: "16px",
    },
    timerDetails: {
        backgroundColor: "var(--bg-green-2)",
    },
    forgotPwd: {
        textAlign: "center",
        textDecoration: "underline",
    },
    loginTabs: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        borderRadius: "15px",
        //backgroundColor: "rgba(0, 204, 204, .05)",
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: "0px",
    },


    myLoginBtn: {

        backgroundColor: "#E1F000 !important",

    }


}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function Login() {
    const auth = useAuth();
    const classes = useStyles();
    const dispatch = useDispatch();
    const siteToken = useSelector((state) => state.saveTokenReducer);
    const [activeTab, setActiveTab] = useState("user");

    const userData = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    console.log("userData", userData);
    // const navigate = useNavigate();
    let userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    const isForgotPasswordClicked = useSelector(state => state.isForgotPasswordReducer);
    console.log("isForgotPasswordClicked", isForgotPasswordClicked);
    //const { loginWithRedirect } = useAuth0();
    // const testRed = useSelector((state) => state.custHeaderReducer);

    const { instance } = useMsal();
    const history = useHistory();
    const errMessage = useSelector((state) => state.errorMessageReducer);
    const { control, handleSubmit } = useForm();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogContent, setDialogContent] = React.useState("");
    const [dialogTitle, setDialogTitle] = React.useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [userDataTemp, setUserDataTemp] = useState({});
    const [expiredTime, setExpiredTime] = useState(Date.now());
    //const [expiredTime, setExpiredTime] = useState("");
    const [isLoader, setIsLoader] = useState(false);

    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [emailHelper, setEmailHelper] = useState("");
    const [otpHelper, setOtpHelper] = useState(null);
    const [pwdDialogOpen, setPwdDialogOpen] = useState(false);
    const [forgotPwdEmail, setForgotPwdEmail] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [enterOTPDialogOpen1, setEnterOTPDialogOpen1] = useState(false);
    const [otpValue, setOtpValue] = useState("");
    const [isOtpValid, setIsOtpValid] = useState(false);

    const [usernameContract, setUsernameContract] = useState("");
    const [extUserEmail, setExtUserEmail] = useState("");
    const [passwordContract, setPasswordContract] = useState("");
    const [emailHelperContract, setEmailHelperContract] = useState("");
    const [passwordHelperContract, setPasswordHelperContract] = useState(null);
    const [newPassword1, setNewPassword1] = useState("");//change password
    const [confirmPassword1, setConfirmPassword1] = useState("");//change password 
    const [isPasswordResetDone, setIsPasswordResetDone] = useState(false);//change password closing popup forcefully
    //newly added

    

    const [externalEmail, setExternalEmail] = useState("");
    const [externalPassWord, setexternalPassWord] = useState("");
    const [OTPValue, setOTPValue] = useState();//real working
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [changePwdOpen, setChangePwdOpen] = useState(false);//change password


    const [OTPValueCustomer, setOTPValueCustomer] = useState("");
    const handleOTPForCustomer = (e) => {
        setOTPValueCustomer(e.target.value);
    }
    function validateEmailspecial(email) {
        return email.includes("@");
    }







    const handleEmail = (e) => {
        console.log("specialemail", e.target.value);
        setExternalEmail(e.target.value);

    }
    const [customerEmail, setCustomerEmail] = useState("");
    const [isOTPRequestForCustomer, setOTPRequestedForCustomer] = useState(false);
    const handleEmailCustomer = (e) => {
        setCustomerEmail(e.target.value);
    }



    const handlePassword = (e) => {
        console.log("specialPasword", e.target.value);
        setexternalPassWord(e.target.value);
    }

    const handleOTP = (e) => {
        let otpVal = e.target.value;


        if (/^\d*$/.test(otpVal)) {
            setOTPValue(otpVal);
        }


    }

    const handleDialogOpen = (content, title) => {
        setDialogTitle(title);
        setDialogContent(content);
        setDialogOpen(true);
    };




    const [openForgotDialog, setOpenForgotDialog] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [forgotEmailError, setForgotEmailError] = useState("");
    const [isForgotLoading, setIsForgotLoading] = useState(false);//states for forgot password


    const handlePwdforgotDialogOpen = () => {
        setOpenForgotDialog(true);
        // setForgotEmail(true);
        setIsForgotPassword(true);
        dispatch(isForgotPasswordAction(true));
    };

    //const handlePwdforgotDialogOpen = () => {
    //    setPwdDialogOpen(true);
    //    setIsForgotPassword(true);
    //    dispatch(isForgotPasswordAction(true));
    //};//old


    const handleForgotDialogClose = () => {
        setOpenForgotDialog(false);
        setForgotEmail("");
        setForgotEmailError("");
    };


    const [resetDialogOpen, setResetDialogOpen] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");


    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);




    const handleForgotEmailChange = (e) => {
        setForgotEmail(e.target.value);

        if (!e.target.value) {
            setForgotEmailError("Email is required");
        } else {
            setForgotEmailError("");
        }
    };


    //const handleForgotSubmit = () => {
    //    const emailRegex = /\S+@\S+\.\S+/;

    //    if (!forgotEmail) {
    //        setForgotEmailError("Email is required");
    //        return;
    //    }


    //    setForgotEmailError("");
    //    setIsForgotLoading(true);

    //    // 🔥 Call API here
    //    const data = {
    //        emailId: forgotEmail,
    //    };

    //    // Example API call
    //    forgotUserPassword(data)
    //        .then((res) => {
    //            setIsForgotLoading(false);

    //            if (res.response) {
    //                handleDialogOpen("Reset link sent to email", "success");

    //                //  optional: redirect to change password flow
    //                // dispatch(isForgotPasswordAction(true));
    //                // history.push("/changePassword");
    //            } else {
    //                handleDialogOpen(res.responseMsg, "error");
    //            }
    //        })
    //        .catch(() => {
    //            setIsForgotLoading(false);
    //            handleDialogOpen("Something went wrong", "error");
    //        });

    //    handleForgotDialogClose();
    //};








    const handlePwdDialogClose = (e, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        setForgotPwdEmail("");
        setEmailHelper("");
        setPwdDialogOpen(false);
    };

    const handleOTPDialogOpen = () => {
        //setOtpValue("");
        setOtpValue("");
        // dispatch(isExternalOTPVerified(false));
        setEnterOTPDialogOpen1(true);
    };
    const handleOTPDialogClose = (e, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        //setOtpValue("");
        //setOtpHelper("");

        setIsGenReportClicked(false);
        setEnterOTPDialogOpen1(false);
    };

    const sendForgotPwdOTP = () => {
        if (isEmailValid) {
            //setForgotPwdEmail('');
            forgotPassword();
        } else {
            setIsEmailValid(false);
            setEmailHelper("Email is mandatory");
        }
    };
    const [generatedOTP, setGeneratedOTP] = useState("");


    //const handleVerifyOTP = () => {

    //    if (otpValue !== generatedOTP) {
    //        handleDialogOpen("Invalid OTP");
    //        return;
    //    }

    //    //  OTP is correct → move to next step
    //    setEnterOTPDialogOpen1(false);//closing verify otp dialog
    //    setResetDialogOpen(true);//opening reset password dialog on validation of otp
    //};

    function handleChangePassword() {

        //  Step 1: Validation
        if (!newPassword1 || !confirmPassword1) {
            setErrorMsg("All fields are required");
            return;
        }

        if (newPassword1 !== confirmPassword1) {
            setErrorMsg("Passwords do not match");
            return;
        }




        setErrorMsg("");

        //  Step 2: Prepare API data
        const data = {
            EmailId: specialUserResponse.response.emailId,
            Password: newPassword1,

        };

        console.log("Sending Change Password Data:", data);


        ResetUserPassword(data)
            .then((res) => {



                if (res?.response == true) {
                    handleDialogOpen(
                        res?.responseMsg,
                        "Success"
                    );
                   // changePwdOpen
                    setIsPasswordResetDone(true);
                    setChangePwdOpen(false);
                    setExternalEmail("");
                    setexternalPassWord("");
                    setIsOTPRequested(false);
                    setOTPValue("");
                  



                } else {
                    handleDialogOpen(
                        res?.responseMsg,
                        "Error"
                    );


                }
            })
            .catch(() => {
                //setIsLoader(false);
                setErrorMsg("Something went wrong");
            });
    }


    const handleResetPassword = () => {

        if (!newPassword || !confirmPassword) {
            setPasswordError("All fields are required");
            return;
        }

        if (newPassword !== confirmPassword) {
            setPasswordError("Passwords do not match");
            return;
        }

        setPasswordError("");


        const data = {
            EmailId: forgotEmail,
            Password: newPassword,
            //GeneratedOTP: otpValue       
        };


        setIsLoader(true);

        ResetUserPassword(data)
            .then((res) => {
                setIsLoader(false);

                if (res) {
                    handleDialogOpen(res?.responseMsg, "Success");//need to checked
                    //setSuccessMsg(res?.responseMsg || "Password changed successfully");//need to check
                    setResetDialogOpen(false);

                    // Optional: redirect to login
                    // history.push("/login");

                } else {
                    setErrorMsg(res?.responseMsg || "Failed to reset password");
                    //  handleDialogOpen("Failed to reset password", "Error");
                }
            })
            .catch(() => {
                setIsLoader(false);
                handleDialogOpen("Something went wrong", "Error");
            });
    };

    //verifyOTP-->1st page  OTPValue
    const handleVerifyOTP1 = () => {

        setPasswordError("");

        const data = {
            EmailId: externalEmail,
            Otp: OTPValue,
        };

        setIsLoader(true);


        verifyOTP(data)
            .then((response) => {
                setIsLoader(false);

                if (response.response === true && specialUserResponse.response.changePassword >0) {

                    let userData = {
                        gid: specialUserResponse.response.gid,
                        roleId: specialUserResponse.response.roleId,
                        roleName: specialUserResponse.response.roleName,
                        emailId: specialUserResponse.response.emailId,
                        firstName: specialUserResponse.response.firstName,
                        userPassword: specialUserResponse.response.password,
                        lastName: specialUserResponse.response.lastName,
                        userId: specialUserResponse.response.id,
                        changePassword: specialUserResponse.response.changePassword,
                        passwordChangedOn: specialUserResponse.response.passwordChangedOn,
                        loginId: specialUserResponse.response.loginId,
                    };

                    // store data (DO NOT REMOVE THIS)
                    dispatch(storeUserDetailsAction(userData));
                    dispatch(saveBearerTokenAction(specialUserResponse?.tokenString));
                    dispatch(saveUserIdAction(specialUserResponse?.uid));
                    dispatch(isForgotPasswordAction(true));




                }

                else if (
                    specialUserResponse.response.roleId == 2 &&
                    (specialUserResponse.response.changePassword === null)
                ) {
                    //  stay on login page
                    //  open popup
                    setChangePwdOpen(true);
                }

                else {
                    handleDialogOpen("OTP did not match, try again", "Error");
                }
            })
    }


    //validate OTP for customer
    const handleVerifyOTPForCustomer = () => {

      

        const data = {
            EmailId: customerEmail,
            Otp: OTPValueCustomer,
        };

        setIsLoader(true);


        verifyOTPForCustomer(data)
            .then((response) => {
                setIsLoader(false);

                if (response.response === true) {

                    let userData = {
                        gid: customerUserResponse.response.gid,
                        roleId: customerUserResponse.response.roleId,
                        roleName: customerUserResponse.response.roleName,
                        emailId: customerUserResponse.response.emailId,
                        firstName: customerUserResponse.response.firstName,
                        userPassword: customerUserResponse.response.password,
                        lastName: customerUserResponse.response.lastName,
                        userId: customerUserResponse.response.id,
                        changePassword: customerUserResponse.response.changePassword,
                        passwordChangedOn: customerUserResponse.response.passwordChangedOn,
                        loginId: customerUserResponse.response.loginId,
                    };

                    // store data (DO NOT REMOVE THIS)
                    dispatch(storeUserDetailsAction(userData));
                    dispatch(saveBearerTokenAction(customerUserResponse?.tokenString));
                    dispatch(saveUserIdAction(customerUserResponse?.uid));
                    dispatch(isForgotPasswordAction(true));




                }

                

                else {
                    handleDialogOpen("OTP did not match, try again", "Error");
                }
            })
    }
        





    //const handleVerifyOTP1 = () => {

    //    setPasswordError("");

    //    const data = {
    //        EmailId: externalEmail,
    //        Otp: OTPValue,
    //    };

    //    setIsLoader(true);

    //    verifyOTP(data)
    //        .then((response) => {
    //            setIsLoader(false);

    //            if (response.response === true) {

    //                //  recreate userData
    //                let userData = {
    //                    gid: specialUserResponse.response.gid,
    //                    roleId: specialUserResponse.response.roleId,
    //                    roleName: specialUserResponse.response.roleName,
    //                    emailId: specialUserResponse.response.emailId,
    //                    firstName: specialUserResponse.response.firstName,
    //                    userPassword: specialUserResponse.response.password,
    //                    lastName: specialUserResponse.response.lastName,
    //                    userId: specialUserResponse.response.id,
    //                    changePassword: specialUserResponse.response.changePassword,
    //                    passwordChangedOn: specialUserResponse.response.passwordChangedOn,
    //                    loginId: specialUserResponse.response.loginId,
    //                };

    //                //  dispatch
    //                dispatch(storeUserDetailsAction(userData));
    //                dispatch(saveBearerTokenAction(specialUserResponse?.tokenString));
    //                dispatch(saveUserIdAction(specialUserResponse?.uid));
    //                dispatch(isForgotPasswordAction(true));

    //                //  IMPORTANT: Navigate
    //                //navigate("/home");

    //            } else {
    //                handleDialogOpen("OTP did not match, try again", "Error");
    //            }
    //        })
    //        .catch(() => {
    //            setIsLoader(false);
    //            handleDialogOpen("Something went wrong", "Error");
    //        });
    //};//till working





    const handleVerifyOTP = () => {

        setPasswordError("");

        const data = {
            EmailId: forgotEmail,
            Otp: otpValue,
        };

        setIsLoader(true);

        verifyOTP(data)
            .then((response) => {
                setIsLoader(false);

                console.log("OTP API Response:", response);

                //  SUCCESS CASE
                if (response?.response === true) {

                    handleDialogOpen(response?.responseMsg || "OTP verified", "Success");

                    setEnterOTPDialogOpen1(false);
                    setResetDialogOpen(true);

                }
                //  FAILURE CASE
                else {
                    handleDialogOpen(response?.responseMsg || "OTP did not match", "Error");
                }
            })
            .catch(() => {
                setIsLoader(false);
                handleDialogOpen("Something went wrong", "Error");
            });
    };



    async function forgotPassword() {
        console.log("forgot password is clicked");
        const userData = {
            UserEmailId: forgotEmail,
        };
        setIsLoader(true);

       

               
        forgotUserPassword(userData)
                    .then((responseAuthenticate) => {
                        if (responseAuthenticate) {
                            if (typeof responseAuthenticate === "object") {
                                //setUserDataTemp(responseAuthenticate);
                                setSpecialUserResponse(responseAuthenticate);
                                setGeneratedOTP(responseAuthenticate.generatedOTP)
                                dispatch(isForgotPasswordAction(true));
                                setIsLoader(false);
                              //  setSuccessMsg(responseAuthenticate?.ResponseMsg || "Password changed successfully");//need to check
                              //  setOtpValue("");
                                setOpenForgotDialog(false);
                               // if (responseAuthenticate?.generatedOTP) {
                                    setEnterOTPDialogOpen1(true);
                               // }
                                // handleSnackOpen(response.responseMsg, "success");//need to check
                                //setEnterOTPDialogOpen(true);
                            } else {
                                if (typeof responseAuthenticate === "string") {
                                    setIsLoader(false);
                                    handleDialogOpen(
                                        responseAuthenticate,
                                        responseAuthenticate.includes("Failed") ? "Error" : "Alert"
                                    );
                                } else {
                                    setIsLoader(false);
                                    handleDialogOpen(
                                        "Invalid user data returned from server",
                                        "Error"
                                    );
                                }
                            }
                        } else {
                            setIsLoader(false);
                            handleDialogOpen("Invalid email", "Error");
                        }
                    })

                    .catch((error) => {
                        setIsLoader(false);
                        handleDialogOpen("Error in external login", "Error");
                    });
           

           
    }

    const handleClose = () => {
        setDialogOpen(false);
        setPwdDialogOpen(false);
    };

    const handleForgotPwdChange = (event) => {
        let emailValid;
        setForgotPwdEmail(event.target.value);
        emailValid =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                event.target.value
            );
        if (!emailValid) {
            setIsEmailValid(false);
            setEmailHelper("Invalid Email");
        } else {
            setIsEmailValid(true);
            setEmailHelper("");
        }
    };

    function isValidEmail(value) {
        const exp =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return exp.test(value);
    }
    function isValidUsername(value) {
        // upper = /[A-Z]/,
        const minMaxLength = /^[\s\S]{8,}$/,
            letter = /[aA-zZ]/,
            number = /[0-9]/,
            special = /[!#$%&'_()*+,-./:;<=>?@[\]^`{|}~]/;

        return (
            letter.test(value) &&
            number.test(value) &&
            special.test(value) &&
            minMaxLength.test(value)
        );
    }
    function validateUsername(value) {
        if (!value) {
            setEmailHelperContract("*Required");
        } else {
            !isValidUsername(value)
                ? setEmailHelperContract("Invalid Username")
                : setEmailHelperContract(null);
        }
    }
    function validateExtEmail(value) {
        if (!value) {
            setEmailHelperContract("*Required");
        } else {
            !isValidEmail(value)
                ? setEmailHelperContract("Invalid Email")
                : setEmailHelperContract(null);
        }
    }
    function validatePassword(value) {
        if (!value) {
            setPasswordHelperContract("*Required");
        } else {
            setPasswordHelperContract(null);
        }
    }
    const handleChangeContractUserName = (e) => {
        setExtUserEmail(e.target.value);
        validateExtEmail(e.target.value);
    };
    const handleChangeContractPassword = (e) => {
        setPasswordContract(e.target.value);
        validatePassword(e.target.value);
    };

    const [isGenReportClicked, setIsGenReportClicked] = useState(false);
    const handleClickContractLogin = () => {
        if (
            extUserEmail == "" ||
            extUserEmail == null ||
            extUserEmail == undefined ||
            !isValidEmail(extUserEmail)
        ) {
            handleDialogOpen("Enter Valid Email");
            return;
        }
        setIsGenReportClicked(true);
        let loginData = {
            userEmailId: extUserEmail,
            password: "",
        };
        navigatetoExternalReport(loginData);
    };

    //AuthenticateCustomerEmail--AuthenticateCustomerEmail
    const [customerUserResponse, setCustomerUserResponse] = useState({});
    function AuthenticateCustomerloginUser() {

        if (!customerEmail) {
            handleDialogOpen("Please enter Email", "Error");
            return;
        }

        if (!validateEmailspecial(customerEmail)) {
            handleDialogOpen("Please enter Correct Email", "Error");
            return;
        }

       

        setIsLoader(true);

        AuthenticateCustomerEmail(customerEmail)
            .then((responseAuthenticate) => {

                setIsLoader(false);

                console.log("API Response:", responseAuthenticate);

                //   Error string from API
                if (typeof responseAuthenticate === "string") {
                    handleDialogOpen(responseAuthenticate, "Error");
                    return;
                }

                //   Success object
                if (typeof responseAuthenticate === "object") {


                    setCustomerUserResponse(responseAuthenticate)
                   
                    setOTPRequestedForCustomer(true);

                } else {
                    handleDialogOpen("Invalid email or password", "Error");
                }
            })
            .catch(() => {
                setIsLoader(false);
                handleDialogOpen("Error in external login", "Error");
            });
    }
   
    function navigatetoExternalReport(loginData) {
        setIsLoader(true);
        validateTheUserBasedOnApi(dispatch)
            //console.log(responseValidate)
            .then((responseValidate) => {
                if (responseValidate.result.response) {
                    console.log(responseValidate.result.objResult.token);
                    authenticateCustomer(
                        responseValidate.result.objResult.token,
                        loginData
                    )
                        .then((responseAuthenticate) => {
                            if (responseAuthenticate) {
                                if (typeof responseAuthenticate === "object") {
                                    setUserDataTemp(responseAuthenticate);
                                    console.log("Response Authenticate", responseAuthenticate);
                                    setIsLoader(false);
                                    // setDialogOpen(true);
                                    setOtpValue("");
                                   // setEnterOTPDialogOpen(true);
                                } else {
                                    if (typeof responseAuthenticate === "string") {
                                        setIsLoader(false);
                                        handleDialogOpen(
                                            responseAuthenticate,
                                            responseAuthenticate.includes("Failed")
                                                ? "Error"
                                                : "Alert"
                                        );
                                    } else {
                                        setIsLoader(false);
                                        handleDialogOpen(
                                            "Invalid user data returned from server",
                                            "Error"
                                        );
                                    }
                                }
                            } else {
                                setIsLoader(false);
                                handleDialogOpen("Invalid email or password", "Error");
                            }
                        })
                        .catch((error) => {
                            setIsLoader(false);
                            handleDialogOpen("Error in external login", error);
                        });
                }
            })
            .catch((error) => {
                setIsLoader(false);
                handleDialogOpen("Error in token generation", error);
            });
    }

    //function contractUserLogin(loginData) {
    //    setIsLoader(true);
    //    validateTheUserBasedOnApi(dispatch, auth)
    //        .then((responseValidate) => {
    //            if (responseValidate.response) {
    //                authenticateContractUser(responseValidate.objResult.token, loginData)
    //                    .then((responseAuthenticate) => {
    //                        if (responseAuthenticate) {
    //                            if (typeof responseAuthenticate === "object") {
    //                                let userData = {
    //                                    gid: responseAuthenticate.gid,
    //                                    roleId: responseAuthenticate.roleId,
    //                                    roleName: responseAuthenticate.roleName,
    //                                    userEmail: responseAuthenticate.userEmail,
    //                                    userFirstName: responseAuthenticate.userFirstName,
    //                                    userLastName: responseAuthenticate.userLastName,
    //                                    userId: responseAuthenticate.userId,
    //                                    supplierId: responseAuthenticate.supplierId,
    //                                };
    //                                dispatch(storeUserDetailsAction(userData));
    //                                setIsLoader(false);
    //                            } else {
    //                                if (typeof responseAuthenticate === "string") {
    //                                    setIsLoader(false);
    //                                    handleDialogOpen(
    //                                        responseAuthenticate,
    //                                        responseAuthenticate.includes("Failed")
    //                                            ? "Error"
    //                                            : "Alert"
    //                                    );
    //                                } else {
    //                                    setIsLoader(false);
    //                                    handleDialogOpen(
    //                                        "Invalid user data returned from server",
    //                                        "Error"
    //                                    );
    //                                }
    //                            }
    //                        } else {
    //                            setIsLoader(false);
    //                            handleDialogOpen("Invalid email or password", "Error");
    //                        }
    //                    })
    //                    .catch((error) => {
    //                        setIsLoader(false);
    //                        handleDialogOpen("Error in external login", "Error");
    //                    });
    //            }
    //        })
    //        .catch((error) => {
    //            handleDialogOpen("Error in token generation", "Error");
    //        });
    //}

    function myIDLogin() {
      /*  dispatch(signinRedirect);*/
    }

    function azureADLogin() {
      
        setIsLoader(true);//added newly
        instance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
            setIsLoader(false);//added newly
        });
    }

    const [specialUserResponse, setSpecialUserResponse] = useState({});
    const [specialUserDataRes, setSpecialUserDataRes] = useState();
    const [OTPvalueSpecialUser, setOTPvalueSpecialUser] = useState("");//not needed
    const [isOTPRequested, setIsOTPRequested] = useState(false);//special user
    const [isOTPRequestedForCustomer, setIsOTPRequestedForCustomer] = useState(false);//customer

    function specialUser() {

        if (!externalEmail) {
            handleDialogOpen("Please enter Email", "Error");
            return;
        }

        if (!validateEmailspecial(externalEmail)) {
            handleDialogOpen("Please enter Correct Email", "Error");
            return;
        }

        if (!externalPassWord) {
            handleDialogOpen("Please enter Password", "Error");
            return;
        }

        setIsLoader(true);

        AuthenticateSpecialUser1(externalEmail, externalPassWord)
            .then((responseAuthenticate) => {

                setIsLoader(false);

                console.log("API Response:", responseAuthenticate);

                //   Error string from API
                if (typeof responseAuthenticate === "string") {
                    handleDialogOpen(responseAuthenticate, "Error");
                    return;
                }

                //   Success object
                if (typeof responseAuthenticate === "object") {

                   

                    setSpecialUserResponse(responseAuthenticate);
                    setIsOTPRequested(true);

                } else {
                    handleDialogOpen("Invalid email or password", "Error");
                }
            })
            .catch(() => {
                setIsLoader(false);
                handleDialogOpen("Error in external login", "Error");
            });
    }


   
    function generateOTPHandler(e) {
        console.log("otpvalue", e.target.value);
        setIsOTPRequested(true);
    }

    function externalUserLogin(userData) {
        setIsLoader(true);
        setEmail(userData.userEmailId);
        setPassword(userData.password);
        validateTheUserBasedOnApi(dispatch)
            //console.log(responseValidate)
            .then((responseValidate) => {
                if (responseValidate.result.response) {
                    console.log(responseValidate.result.objResult.token);
                    authenticateExternalUser(
                        responseValidate.result.objResult.token,
                        userData
                    )
                        .then((responseAuthenticate) => {
                            if (responseAuthenticate) {
                                if (typeof responseAuthenticate === "object") {
                                    setUserDataTemp(responseAuthenticate);
                                    setIsLoader(false);
                                    // setDialogOpen(true);
                                    setOtpValue("");
                                   // setEnterOTPDialogOpen(true);
                                } else {
                                    if (typeof responseAuthenticate === "string") {
                                        setIsLoader(false);
                                        handleDialogOpen(
                                            responseAuthenticate,
                                            responseAuthenticate.includes("Failed")
                                                ? "Error"
                                                : "Alert"
                                        );
                                    } else {
                                        setIsLoader(false);
                                        handleDialogOpen(
                                            "Invalid user data returned from server",
                                            "Error"
                                        );
                                    }
                                }
                            } else {
                                setIsLoader(false);
                                handleDialogOpen("Invalid email or password", "Error");
                            }
                        })
                        .catch((error) => {
                            setIsLoader(false);
                            handleDialogOpen("Error in external login", "Error");
                        });
                }
            })
            .catch((error) => {
                handleDialogOpen("Error in token generation", "Error");
            });
    }

    function VerifyOTP() {
        if (otpValue && userDataTemp.generatedOTP === otpValue) {
            let userData = {
                gid: userDataTemp.gid,
                roleId: userDataTemp.roleId,
                roleName: userDataTemp.roleName,
                // userEmail: userDataTemp.emailId,
                emailId: userDataTemp.emailId,
                userFirstName: userDataTemp.firstName,
                userPassword: userDataTemp.userPassword,
                userLastName: userDataTemp.lastName,
                userId: userDataTemp.userId,
                //supplierId: userDataTemp.supplierId,
                changePassword: userDataTemp.changePassword,
                passwordChangedOn: userDataTemp.passwordChangedOn,
                loginId: userDataTemp.id,
            };
            console.log(userData.roleId);
            dispatch(storeUserDetailsAction(userData));
           // dispatch(isVerifiedOTPAction(true));
        } else {
            handleDialogOpen("OTP did not match, try again","Error");
        }
    }


    //useEffect(() => {
    //    if (userData) {

    //        if (userData.changePassword === null) {

    //            // ✅ First-time login → open dialog
    //            setResetDialogOpen(true);

    //        } else {

    //            // ✅ Normal login → go to home page
    //            history.push("/");
    //        }
    //    }
    //}, [userData]);

    function VerifyOTPForSpecialUser() {
        if (OTPValue && specialUserResponse.otp === OTPValue) {
            let userData = {
                gid: specialUserResponse.response.gid,
                roleId: specialUserResponse.response.roleId,
                roleName: specialUserResponse.response.roleName,
                // userEmail: userDataTemp.emailId,
                emailId: specialUserResponse.response.emailId,
                firstName: specialUserResponse.response.firstName,
                userPassword: specialUserResponse.response.password,
                lastName: specialUserResponse.response.lastName,
                userId: specialUserResponse.response.id,
                //supplierId: userDataTemp.supplierId,
                changePassword: specialUserResponse.response.changePassword,
                passwordChangedOn: specialUserResponse.response.passwordChangedOn,
                loginId: specialUserResponse.response.loginId,
            };
            console.log("userroleidfromverifyotp", userData.roleId);


            dispatch(storeUserDetailsAction(userData));

            dispatch(saveBearerTokenAction(specialUserResponse?.tokenString));
            dispatch(saveUserIdAction(specialUserResponse?.uid));
            dispatch(isForgotPasswordAction(true));
         


            

            
          //  dispatch(isVerifiedOTPAction(true));
        } else {
            handleDialogOpen("OTP did not match, try again","Error");
        }
    }

    function verifyExtLoginOTP() {
        if (otpValue && userDataTemp.generatedOTP === otpValue) {
            dispatch(isExternalOTPVerified(true));
            handleDialogOpen("OTP verfied","Error");
        } else {
            handleDialogOpen("OTP did not match, try again","Error");
        }
    }

    const ResendOTP = (e) => {
        handleClose.call();
        handleOTPDialogClose();

        //handleOTPDialogOpen();
        //setOtpValue("");

        let userData = {
            userEmailId: email,
            password: password,
        };
        externalUserLogin(userData);
    };
    const ResendForgotPwdOTP = () => {
        handleOTPDialogClose();
        let userData = {
            userEmailId: email,
        };
        forgotPassword();
    };

    //Related to forgot password
    function VerifyForgotPwdOTP() {
        let userData = {
            //userEmail: userDataTemp.userEmail,
            emailId: userDataTemp.emailId,
            roleId: userDataTemp.roleId,
        };
        if (otpValue && userDataTemp.generatedOTP === otpValue) {
            let userData = {
                gid: userDataTemp.gid,
                roleId: userDataTemp.roleId,
                roleName: userDataTemp.roleName,
                //userEmail: userDataTemp.emailId,
                emailId: userDataTemp.emailId,
                userFirstName: userDataTemp.firstName,
                userPassword: userDataTemp.userPassword,
                userLastName: userDataTemp.lastName,
                userId: userDataTemp.userId,
                //supplierId: userDataTemp.supplierId,
                changePassword: userDataTemp.changePassword,
                passwordChangedOn: userDataTemp.passwordChangedOn,
            };

            dispatch(storeUserDetailsAction(userData));
            dispatch(custHeaderAction("CustomizedHeader"));
            dispatch(isVerifiedOTPAction(true));
            dispatch(isForgotPasswordAction(true));
        } else {
            handleDialogOpen("OTP did not match, try again","Error");
        }
    }

    function handleChangeOtp(event) {
        validateOTP(event.target.value);
        setOtpValue(event.target.value);
    }

    function validateOTP(value) {
        if (!value) {
            setOtpHelper("OTP is mandatory");
        } else {
            const re = /^\d*$/;
            if (!re.test(value)) {
                setOtpHelper("OTP must be integer");
                setIsOtpValid(false);
            } else if (value.toString().length !== 6) {
                setOtpHelper("OTP must be of 6 digit");
                setIsOtpValid(false);
            } else if (value !== userDataTemp.generatedOTP) {
                setOtpHelper("OTP mismatch");
                setIsOtpValid(false);
            } else {
                setOtpHelper(null);
                setIsOtpValid(true);
            }
        }
    }

    //useEffect(() => {
    //    if (enterOTPDialogOpen) {
    //        setExpiredTime(Date.now() + 180000);
    //        setTimeout(function () {
    //            // setEnterOTPDialogOpen(false);
    //            handleOTPDialogClose();
    //        }, 180000);
    //    }
    //    // isExternalOTPVerified(false);
    //}, [enterOTPDialogOpen]);

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="bg-login-register">
            <div className={classes.root}>
                <div className="page-wrapper"
                                  style={{ marginLeft: "450px", marginTop: '100px' }}

                  
                >
                    <Container
                        // style={{ backgroundColor: "white", height: '50%', width: '60%', paddingLeft: 0, paddingRight: 0, paddingBottom: "20px" }} 

                        style={{

                            backgroundColor: "white",
                            width: "500px",
                            marginLeft: "auto",   // pushes it to right
                            marginRight: "50px",  // space from right edge
                            paddingBottom: "20px",
                            paddingLeft: 0, paddingRight: 0,

                        }}

                        className="login-container"  >

                    <AppBar position="static">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                           // variant="fullWidth"   // ensures all tabs in one row
                        >
                                <Tab label="Customer" />
                                <Tab label="Innomotics Internal User" />
                                <Tab label="Special User" />
                        </Tabs>
                    </AppBar>

                    {/* Tab Content */}
                    <div className="content">
                        {value === 0 && (
                                <div>
                                    <div className="pt-login-siemens_user" style={{ fontStyle: "normal" }} >
                                      {/*  <h3 className="heading-margin-5tb-0lr" style={{ fontStyle: "normal" }} >Customer</h3>*/}
                                        {/*  <p style={{ fontStyle: "normal" }} >Special User Login</p>*/}


                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "15px",
                                            justifyContent: "center",
                                            alignItems: "center",  //  Center inputs
                                            width: "100%",
                                            marginTop:'10px'
                                        }}>
                                            <div>
                                                <input
                                                    placeholder="Email"
                                                    required
                                                    style={{
                                                        width: "300px",   //  Increased width
                                                        padding: "10px",
                                                    }}
                                                    
                                                    type="email"
                                                    onChange={handleEmailCustomer}
                                                    value={customerEmail}
                                                />
                                            </div>

                                           
                                        </div>

                                    
                                        <div className="d-flex jc-center myid-login-btn-block">

                                            <Button

                                                style={{
                                                    backgroundColor: '#E1F000',
                                                    color: '#08191F'
                                                }}

                                                className={`myid-login-btn`}
                                                id="SiemensIdLogin"
                                                disabled={!customerEmail}
                                                onClick={AuthenticateCustomerloginUser}//earlier
                                            //onClick={generateOTPHandler}
                                            >
                                                <span>Generate OTP</span>
                                            </Button>

                                        </div>

                                        {isOTPRequestForCustomer ?
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "15px",
                                                    justifyContent: "center",
                                                    alignItems: "center",  //  Center inputs
                                                    width: "100%",
                                                    marginTop: "10px"
                                                }}>
                                                   
                                                    <input
                                                        placeholder="please enter OTP"

                                                        style={{
                                                            width: "150px",   //  Increased width
                                                            padding: "10px",
                                                        }}
                                                        maxLength={6}  //maximum 6 digits
                                                        type="otp"
                                                        onChange={handleOTPForCustomer}
                                                        value={OTPValueCustomer}
                                                    />
                                                </div>

                                                <div className="d-flex jc-center myid-login-btn-block">

                                                    <Button

                                                        style={{
                                                            backgroundColor: '#E1F000',
                                                            color: '#08191F'
                                                        }}
                                                        disabled={!OTPValueCustomer}
                                                        className={`myid-login-btn`}
                                                        id="SiemensIdLogin"
                                                        //  onClick={VerifyOTPForSpecialUser}
                                                        onClick={handleVerifyOTPForCustomer}

                                                    >
                                                        <span>Validate OTP</span>
                                                    </Button>

                                                </div>

                                            </div> : <></>}

                                          






                                        {/*<div className={classes.forgotPwd}>*/}
                                        {/*    <h5*/}
                                        {/*        className="forget-pwd-cursor"*/}

                                        {/*        onClick={handlePwdforgotDialogOpen}*/}
                                        {/*    >*/}
                                        {/*        Forgot Password*/}
                                        {/*    </h5>*/}
                                        {/*</div>*/}




                                        {OTPValue && OTPValue.length !== 6 && (
                                            <span style={{ color: "red", fontSize: "12px" }}>
                                                OTP must be 6 digits
                                            </span>
                                        )}



                                    </div>
                                {/*<h2>Customer Login</h2>*/}
          
                                {/*    */}{/* <button className="btn">MyID Login</button>*/}
                                {/*    <div className="d-flex jc-center myid-login-btn-block" style={{ marginBottom:'20px' }}>*/}

                                {/*    <Button*/}

                                {/*        style={{*/}
                                {/*            backgroundColor: '#E1F000',*/}
                                {/*            color: '#08191F'*/}
                                {/*        }}*/}

                                {/*        className={`myid-login-btn`}*/}
                                {/*        id="SiemensIdLogin"*/}
                                {/*       // onClick={azureADLogin}*/}
                                {/*    >*/}
                                {/*        <span>Customer Login</span>*/}
                                {/*    </Button>*/}

                                {/*</div>*/}
                            </div>
                        )}

                        {value === 1 && (
                            <div>
                              {/*  <h2>Innomotics Internal Login</h2>*/}
                                    {/*  <p>Login using Vendor credentials</p>*/}
                                    <p style={{ fontStyle: "normal", marginLeft: "100px" }} >If you are a Internal (Innomotics) User, login</p>

                                    <div className="d-flex jc-center myid-login-btn-block" style={{ marginBottom: '20px' }}>
                                             <Button

                                        style={{
                                            backgroundColor: '#E1F000',
                                            color: '#08191F'
                                        }}

                                        className={`myid-login-btn`}
                                        id="SiemensIdLogin"
                                        onClick={azureADLogin}
                                        >
                                        <span>Login</span>
                                        </Button>
                                    </div>
                            </div>
                        )}

                        {value === 2 && (
                                <div>
                                    <div className="pt-login-siemens_user" style={{ fontStyle: "normal" }} >
                                     {/*   <h3 className="heading-margin-5tb-0lr" style={{ fontStyle: "normal" }} >Special User</h3>*/}
                                        {/*  <p style={{ fontStyle: "normal" }} >Special User Login</p>*/}


                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "15px",
                                            justifyContent: "center",
                                            alignItems: "center",  //  Center inputs
                                            width: "100%",
                                            marginTop: '10px'
                                        }}>
                                            <div>
                                                <input
                                                    placeholder="Email"
                                                    required
                                                    style={{
                                                        width: "300px",   //  Increased width
                                                        padding: "10px",
                                                    }}

                                                    type="email"
                                                    onChange={handleEmail}
                                                    value={externalEmail}
                                                />
                                            </div>

                                            <div>
                                                <input
                                                    placeholder="Password"
                                                    required
                                                    style={{
                                                        width: "300px",   //  Increased width
                                                        padding: "10px",
                                                    }}

                                                    type="password"
                                                    onChange={handlePassword}
                                                    value={externalPassWord}
                                                />
                                            </div>
                                        </div>


                                        <div className="d-flex jc-center myid-login-btn-block">

                                            <Button

                                                style={{
                                                    backgroundColor: '#E1F000',
                                                    color: '#08191F'
                                                }}

                                                className={`myid-login-btn`}
                                                id="SiemensIdLogin"
                                                disabled={!externalEmail || !externalPassWord || isOTPRequested}
                                                onClick={specialUser}//earlier
                                            //onClick={generateOTPHandler}
                                            >
                                                <span>Generate OTP</span>
                                            </Button>

                                        </div>

                                        {isOTPRequested ?
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "15px",
                                                    justifyContent: "center",
                                                    alignItems: "center",  //  Center inputs
                                                    width: "100%",
                                                    marginTop: "10px"
                                                }}>
                                                    <input
                                                        placeholder="please enter OTP"

                                                        style={{
                                                            width: "150px",   //  Increased width
                                                            padding: "10px",
                                                        }}
                                                        maxLength={6}  //maximum 6 digits
                                                        type="otp"
                                                        onChange={handleOTP}
                                                        value={OTPValue}
                                                    />
                                                </div>

                                                <div className="d-flex jc-center myid-login-btn-block">

                                                    <Button

                                                        style={{
                                                            backgroundColor: '#E1F000',
                                                            color: '#08191F'
                                                        }}
                                                        disabled={!OTPValue}
                                                        className={`myid-login-btn`}
                                                        id="SiemensIdLogin"
                                                        //  onClick={VerifyOTPForSpecialUser}
                                                        onClick={handleVerifyOTP1}

                                                    >
                                                        <span>Validate OTP</span>
                                                    </Button>

                                                </div>

                                            </div>

                                            : <></>}






                                        <div className={classes.forgotPwd}>
                                            <h5
                                                className="forget-pwd-cursor"

                                                onClick={handlePwdforgotDialogOpen}
                                            >
                                                Forgot Password
                                            </h5>
                                        </div>




                                        {OTPValue && OTPValue.length !== 6 && (
                                            <span style={{ color: "red", fontSize: "12px" }}>
                                                OTP must be 6 digits
                                            </span>
                                        )}



                                    </div>
                                {/*<h2>Special User Login</h2>*/}
                                {/*    <div className="d-flex jc-center myid-login-btn-block" style={{ marginBottom: '20px' }}>*/}
                                {/*            <Button*/}

                                {/*        style={{*/}
                                {/*            backgroundColor: '#E1F000',*/}
                                {/*            color: '#08191F'*/}
                                {/*        }}*/}

                                {/*        className={`myid-login-btn`}*/}
                                {/*        id="SiemensIdLogin"*/}
                                {/*    // onClick={azureADLogin}*/}
                                {/*    >*/}
                                {/*        <span>Customer Login</span>*/}
                                {/*        </Button>*/}
                                {/*    </div>*/}
                            </div>
                        )}
                    </div>

                    </Container>
                </div>
                
                {/*<Container>*/}
                {/*    <Grid container className="pt-lr-mobileContainer" style={{ alignItems: "flex-start", paddingTop: "80px" }}>*/}

                {/*        <Grid item xs={12}>*/}
                {/*            <div className="pt-login-logo-block">*/}
                {/*                */}{/* logo */}
                {/*            </div>*/}
                {/*        </Grid>*/}

                {/*        */}{/* LEFT SIDE (background text area stays same) */}
                {/*        <Grid item xs={12} sm={10} md={6} className="pt-lr--project-block">*/}
                {/*        </Grid>*/}

                {/*        */}{/* ✅ ADD SPACER (this pushes content right) */}
                {/*        <Grid item md={2}></Grid>*/}

                {/*        */}{/* ✅ LOGIN BOX (reduced width + pushed right) */}
                {/*        <Grid*/}
                {/*            item*/}
                {/*            xs={12}*/}
                {/*            sm={10}*/}
                {/*            md={4}*/}
                {/*            className="pt-lr-master-block"*/}
                {/*        >*/}
                {/*            <div className={classes.loginTabs}>*/}
                {/*                <AppBar position="static">*/}
                {/*                    <Tabs*/}
                {/*                        value={value}*/}
                {/*                        onChange={handleChange}*/}
                {/*                        aria-label="simple tabs example"*/}
                {/*                        variant="scrollable"*/}
                {/*                        scrollButtons="auto"*/}
                {/*                    >*/}
                {/*                        <Tab label="Login" className="pr-tab-2i" {...a11yProps(0)} />*/}
                {/*                    </Tabs>*/}
                {/*                </AppBar>*/}

                {/*                <TabPanel value={value} index={0}>*/}
                {/*                    <div className="pt-login-siemens_user" style={{ fontStyle: "normal" }} >*/}
                {/*                        <h3 className="heading-margin-5tb-0lr" style={{ fontStyle: "normal" }} >Users Login</h3>*/}
                {/*                        <p style={{ fontStyle: "normal" }} >If you are a Internal (Innomotics) User, login</p>*/}

                {/*                        <div className="d-flex jc-center myid-login-btn-block">*/}
                                           
                {/*                                <Button*/}

                {/*                                    style={{*/}
                {/*                                        backgroundColor: '#E1F000',*/}
                {/*                                        color: '#08191F'*/}
                {/*                                    }}*/}

                {/*                                    className={`myid-login-btn`}*/}
                {/*                                    id="SiemensIdLogin"*/}
                {/*                                    onClick={azureADLogin}*/}
                {/*                                >*/}
                {/*                                    <span>Login</span>*/}
                {/*                                </Button>*/}
                                          
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                </TabPanel>*/}

                {/*                <TabPanel value={value} index={0} style={{marginTop:'-30px'} }>*/}
                {/*                    <div className="pt-login-siemens_user" style={{ fontStyle: "normal" }} >*/}
                {/*                        <h3 className="heading-margin-5tb-0lr" style={{ fontStyle: "normal" }} >Customer/Special User</h3>*/}
                {/*                      */}{/*  <p style={{ fontStyle: "normal" }} >Special User Login</p>*/}
                                       

                {/*                        <div style={{*/}
                {/*                            display: "flex",*/}
                {/*                            flexDirection: "column",*/}
                {/*                            gap: "15px",*/}
                {/*                            justifyContent: "center",*/}
                {/*                            alignItems: "center",  //  Center inputs*/}
                {/*                            width: "100%",*/}
                {/*           }}>*/}
                {/*                            <div>*/}
                {/*                                <input*/}
                {/*                                    placeholder="Email"*/}
                {/*                                    required*/}
                {/*                                    style={{*/}
                {/*                                        width: "300px",   //  Increased width*/}
                {/*                                        padding: "10px",*/}
                {/*                                    }}*/}

                {/*                                    type="email"*/}
                {/*                                    onChange={handleEmail}*/}
                {/*                                    value={externalEmail }*/}
                {/*                                />*/}
                {/*                            </div>*/}

                {/*                            <div>*/}
                {/*                                <input*/}
                {/*                                    placeholder="Password"*/}
                {/*                                    required*/}
                {/*                                    style={{*/}
                {/*                                        width: "300px",   //  Increased width*/}
                {/*                                        padding: "10px",*/}
                {/*                                    }}*/}

                {/*                                    type="password"*/}
                {/*                                    onChange={handlePassword}*/}
                {/*                                    value={externalPassWord}*/}
                {/*                                />*/}
                {/*                            </div>*/}
                {/*                        </div>*/}


                {/*                        <div className="d-flex jc-center myid-login-btn-block">*/}
                                           
                {/*                            <Button*/}

                {/*                                style={{*/}
                {/*                                    backgroundColor: '#E1F000',*/}
                {/*                                    color: '#08191F'*/}
                {/*                                }}*/}

                {/*                                className={`myid-login-btn`}*/}
                {/*                                id="SiemensIdLogin"*/}
                {/*                                disabled={!externalEmail || !externalPassWord || isOTPRequested}*/}
                {/*                                 onClick={specialUser}//earlier*/}
                {/*                                //onClick={generateOTPHandler}*/}
                {/*                            >*/}
                {/*                                <span>Generate OTP</span>*/}
                {/*                            </Button>*/}

                {/*                        </div>*/}
                                      
                {/*                        {isOTPRequested  ?    */}
                {/*                           <div> */}
                {/*                                 <div style={{*/}
                {/*                            display: "flex",*/}
                {/*                        flexDirection: "column",*/}
                {/*                        gap: "15px",*/}
                {/*                        justifyContent: "center",*/}
                {/*                        alignItems: "center",  //  Center inputs*/}
                {/*                            width: "100%",*/}
                {/*                            marginTop:"10px"*/}
                {/*                        }}>*/}
                {/*                            <input*/}
                {/*                                placeholder="please enter OTP"*/}
                                                
                {/*                                style={{*/}
                {/*                                    width: "150px",   //  Increased width*/}
                {/*                                    padding: "10px",*/}
                {/*                                }}*/}
                {/*                                        maxLength={6}  //maximum 6 digits*/}
                {/*                                type="otp"*/}
                {/*                                onChange={handleOTP}*/}
                {/*                                value={OTPValue}*/}
                {/*                            />*/}
                {/*                        </div>*/}

                {/*                                  <div className="d-flex jc-center myid-login-btn-block">*/}

                {/*                            <Button*/}

                {/*                                        style={{*/}
                {/*                                            backgroundColor: '#E1F000',*/}
                {/*                                            color: '#08191F'*/}
                {/*                                        }}*/}
                {/*                                        disabled={!OTPValue}*/}
                {/*                                        className={`myid-login-btn`}*/}
                {/*                                        id="SiemensIdLogin"*/}
                {/*                                        //  onClick={VerifyOTPForSpecialUser}*/}
                {/*                                        onClick={handleVerifyOTP1 }*/}
                                               
                {/*                            >*/}
                {/*                                <span>Validate OTP</span>*/}
                {/*                            </Button>*/}

                {/*                                </div>*/}

                {/*                            </div>*/}

                {/*                            : <></>}*/}




                                        

                {/*                        <div className={classes.forgotPwd}>*/}
                {/*                            <h5*/}
                {/*                                className="forget-pwd-cursor"*/}
                         
                {/*                                onClick={handlePwdforgotDialogOpen}*/}
                {/*                            >*/}
                {/*                                Forgot Password*/}
                {/*                            </h5>*/}
                {/*                        </div>*/}




                {/*                        {OTPValue && OTPValue.length !== 6 && (*/}
                {/*                            <span style={{ color: "red", fontSize: "12px" }}>*/}
                {/*                                OTP must be 6 digits*/}
                {/*                            </span>*/}
                {/*                        )}*/}



                {/*                    </div>*/}
                {/*                </TabPanel>*/}
                {/*            </div>*/}
                {/*        </Grid>*/}

                {/*    </Grid>*/}
                {/*</Container>*/}


                <Dialog open={dialogOpen} onClose={handleClose}>
                    <DialogTitle>
                        {dialogTitle}
                        <IconButton
                            aria-label="close"
                            className={classes.closeButton}
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText>
                            {dialogContent}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button style={{
                            backgroundColor: '#E1F000',
                            color: '#08191F'
                        }} onClick={handleClose} color="primary">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>



               {/* forgot password dialog*/}
                <Dialog open={openForgotDialog} onClose={handleForgotDialogClose}>
                    <DialogTitle>Forgot Password</DialogTitle>

                    <DialogContent>
                        <TextField
                            label="Enter your email"
                            fullWidth
                            value={forgotEmail}
                            onChange={handleForgotEmailChange}
                            error={!!forgotEmailError}
                            helperText={forgotEmailError}
                            variant="outlined"
                            margin="dense"
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button style={{
                            backgroundColor: '#E1F000',
                            color: '#08191F'
                        }}
                            onClick={handleForgotDialogClose} >
                            Cancel
                        </Button>

                        <Button
                            onClick={forgotPassword}
                           
                            style={{
                                backgroundColor: '#E1F000',
                                color: '#08191F'
                            }}
                            variant="contained"
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>


                {/*  otpchecking for reset password*/}


                <Dialog open={enterOTPDialogOpen1} onClose={() => setEnterOTPDialogOpen1(false)}>
                    <DialogTitle>Verify OTP</DialogTitle>

                    <DialogContent>
                        <TextField
                            label="Enter OTP"
                            fullWidth
                            value={otpValue}
                            onChange={(e) => setOtpValue(e.target.value)}
                            variant="outlined"
                            margin="dense"
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button style={{
                            backgroundColor: '#E1F000',
                            color: '#08191F'
                        }}
                            onClick={() => setEnterOTPDialogOpen1(false)}>
                            Cancel
                        </Button>

                        <Button
                            onClick={handleVerifyOTP}
                           
                            style={{
                                backgroundColor: '#E1F000',
                                color: '#08191F'
                            }}
                            //variant="contained"
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={resetDialogOpen} onClose={() => setResetDialogOpen(false)}>
                    <DialogTitle>Reset Password</DialogTitle>

                    <DialogContent>



                        <TextField
                            label="New Password"
                            type={showNewPassword ? "text" : "password"}
                            fullWidth
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            margin="dense"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                        >
                                            {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />


                        <TextField
                            label="Confirm Password"
                            type={showConfirmPassword ? "text" : "password"}
                            fullWidth
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            margin="dense"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />


                        {passwordError && (
                            <p style={{ color: "red" }}>{passwordError}</p>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button style={{
                            backgroundColor: '#E1F000',
                            color: '#08191F'
                        }}
                            onClick={() => setResetDialogOpen(false)}>
                            Cancel
                        </Button>

                        <Button
                            onClick={handleResetPassword}
                            style={{
                                backgroundColor: '#E1F000',
                                color: '#08191F'
                            }}
                            //color="primary"
                            //variant="contained"
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>




                {successMsg && (
                    <div style={{ color: "green", marginTop: "8px" }}>
                        {successMsg}
                        <button onClick={() => setSuccessMsg("")} style={{ marginLeft: "10px" }}>
                            ✕
                        </button>
                    </div>
                )}


                {/*  change password*/}
               {/* //disableEscapeKeyDown*/}
             
                <Dialog open={changePwdOpen && !isPasswordResetDone}>
                        <DialogTitle>Change Password</DialogTitle>

                        <DialogContent>

                            {/*  OLD PASSWORD (Only for normal user) */}

                            {/*<TextField*/}
                            {/*    label="Old Password"*/}
                            {/*    type={showOldPassword ? "text" : "password"}*/}
                            {/*    fullWidth*/}
                            {/*    margin="dense"*/}
                            {/*    value={oldPassword}*/}
                            {/*    onChange={(e) => setOldPassword(e.target.value)}*/}
                            {/*    InputProps={{*/}
                            {/*        endAdornment: (*/}
                            {/*            <InputAdornment position="end">*/}
                            {/*                <IconButton*/}
                            {/*                    onClick={() => setShowOldPassword(!showOldPassword)}*/}
                            {/*                >*/}
                            {/*                    {showOldPassword ? <Visibility /> : <VisibilityOff />}*/}
                            {/*                </IconButton>*/}
                            {/*            </InputAdornment>*/}
                            {/*        )*/}
                            {/*    }}*/}
                            {/*/>*/}


                            {/* NEW PASSWORD */}
                            <TextField
                                label="New Password"
                                type={showNewPassword ? "text" : "password"}
                                fullWidth
                                margin="dense"
                            value={newPassword1}
                                onChange={(e) => setNewPassword1(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowNewPassword(!showNewPassword)}
                                            >
                                                {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                           
                            {/*  CONFIRM PASSWORD */}
                            <TextField
                                label="Confirm Password"
                                type={showConfirmPassword ? "text" : "password"}
                                fullWidth
                                margin="dense"
                            value={confirmPassword1}
                            onChange={(e) => setConfirmPassword1(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            >
                                                {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />

                            {/*  Error */}
                            {errorMsg && (
                                <p style={{ color: "red", marginTop: "8px" }}>{errorMsg}</p>
                            )}

                        </DialogContent>

                        <DialogActions>

                            {/*  Cancel disabled on first login */}
                         
                                <Button
                                    style={{
                                        backgroundColor: '#E1F000',
                                        color: '#08191F'
                                    }}
                                    onClick={() => setChangePwdOpen(false)}>
                                    Cancel
                                </Button>
                            

                            <Button
                                // color="primary"
                                style={{
                                    backgroundColor: '#E1F000',
                                    color: '#08191F'
                                }}
                                variant="contained"
                                onClick={handleChangePassword}
                            >
                                Submit
                            </Button>

                        </DialogActions>
                    </Dialog> 

                {errorMsg && (
                    <div style={{ color: "red", marginTop: "8px" }}>
                        {errorMsg}
                        <button onClick={() => setErrorMsg("")} style={{ marginLeft: "10px" }}>
                            ✕
                        </button>
                    </div>
                )}

                
                {isLoader ? <Loader /> : <></>}
            </div>
        </div>
    );
}
